import { useEffect, useState } from 'react'

import { Link, useNavigate } from 'react-router-dom'

import noFoundSvg from '../../assets/illustration/no-found-page.svg'

import { Container } from './styles'

export function NotFoundPage() {
  const [counter, setCounter] = useState(10)

  const navigate = useNavigate()

  useEffect(() => {
    let timeoutId
    if (counter !== 0) {
      timeoutId = setTimeout(() => {
        setCounter((prevState) => prevState - 1)
      }, 1000)
    } else {
      navigate('/')
    }
    return () => {
      clearTimeout(timeoutId)
    }
  }, [counter, navigate])

  return (
    <Container>
      <img
        src={noFoundSvg}
        alt=""
      />

      <h1>
        Página não encontrada. Aguarde <span>{counter}</span> segundos ou
        <Link to="/"> Clique Aqui</Link> para voltar
      </h1>
    </Container>
  )
}
